import React from 'react';
import {ActionContainer, ConfirmContainer} from 'pages/Employee/components/style';

const ConfirmModal = ({actions, className,actionclass}) => {
  return (
    <>
      <ActionContainer className={actionclass}>
          <ConfirmContainer className={`${className} confirm_modal`}>
             {actions}
          </ConfirmContainer>
          </ActionContainer>
    </>
  );
};

export default ConfirmModal;
